export const i18nCdpNamespace = "app_cldp_common";
